import { html, attr, type Signal, ForEach, When } from '@tempots/dom'
import { Anchor } from '@tempots/ui'
import { Icon } from '@tempots/beatui'
import type { ActionDetail } from '@/services/types'
import { Workspace } from '@/state/workspace'

export interface ActionHeaderOptions {
  actionName: Signal<string>
  action: Signal<ActionDetail | null>
}

export function ActionHeader({ actionName, action }: ActionHeaderOptions) {
  // Extract tags from action
  const tags = action.map((a) => a?.tags ?? [])

  return html.div(
    attr.class('flex items-center gap-3'),
    Anchor(
      {
        href: Workspace.projectId.map(
          (pid) => Workspace.projectUrl('/actions', pid) ?? '#'
        ),
      },
      attr.class('text-gray-400 hover:text-gray-600'),
      Icon({ icon: 'mdi:chevron-left' }, attr.class('w-5 h-5'))
    ),
    html.div(
      attr.class(
        'w-10 h-10 bg-brand-100 rounded-lg flex items-center justify-center'
      ),
      Icon({ icon: 'mdi:lightning-bolt' }, attr.class('w-5 h-5 text-brand-600'))
    ),
    html.div(
      attr.class('flex flex-col gap-1'),
      html.h1(attr.class('text-lg font-semibold text-gray-900'), actionName),
      When(
        tags.map((t) => t.length > 0),
        () =>
          html.div(
            attr.class('flex flex-wrap gap-1'),
            ForEach(tags, (tag) =>
              html.span(
                attr.class(
                  'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-brand-100 text-brand-800'
                ),
                tag.map((t) => formatTagName(t))
              )
            )
          )
      )
    )
  )
}

function formatTagName(tag: string): string {
  return tag.charAt(0).toUpperCase() + tag.slice(1)
}
